import './en';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/bs-moment/locale/index.js
// module id = 1032
// module chunks = 0